/**
 * Buscador FiboSearch en el header: lupa abre el panel, click fuera o Escape lo cierra.
 */
export function initHeaderSearch() {
    const root = document.querySelector('.header-search');
    const toggle = root?.querySelector('.header-search-toggle');
    const panel = root?.querySelector('.header-search-panel');

    if (!root || !toggle || !panel) {
        return;
    }

    const input = () => panel.querySelector('.dgwt-wcas-search-input');

    const isFiboDropdown = (node) =>
        Boolean(
            node?.closest?.(
                '.dgwt-wcas-suggestions-wrapp, .dgwt-wcas-details-wrapp, .dgwt-wcas-suggestions-wrapp, .dgwt-wcas-preloader'
            )
        );

    const open = () => {
        root.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
            input()?.focus();
        });
    };

    const close = () => {
        root.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (root.classList.contains('is-open')) {
            close();
        } else {
            open();
        }
    });

    document.addEventListener('click', (event) => {
        if (!root.classList.contains('is-open')) {
            return;
        }
        const target = event.target;
        if (root.contains(target) || isFiboDropdown(target)) {
            return;
        }
        close();
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && root.classList.contains('is-open')) {
            close();
            toggle.focus();
        }
    });
}
